import * as actionConfig from '@Actions/config';
import selectorLogin from '@Components/login/selector';
import  formOrigin  from '@Constants/formOrigin';
import * as util from '@Util/index';
import { isFieldDataTypeDashboardEvolution, isFieldDataTypeReportGenerator } from '@Constants/typeFields';

// Action Types
export const FETCH_FORM_FIELDS_REQUEST = 'FETCH_FORM_FIELDS_REQUEST';
export const FETCH_FORM_FIELDS_SUCCESS = 'FETCH_FORM_FIELDS_SUCCESS';
export const FETCH_FORM_FIELDS_ERROR = 'FETCH_FORM_FIELDS_ERROR';

export const CLEAR_FORM_FIELDS = 'CLEAR_FORM_FIELDS';

// Action Creators
const fetchFormFieldsRequest = (formId) => ({
  type: FETCH_FORM_FIELDS_REQUEST,
  payload: { formId }
});

const fetchFormFieldsSuccess = (formId, fields) => ({
  type: FETCH_FORM_FIELDS_SUCCESS,
  payload: { formId, fields }
});

const fetchFormFieldsError = (formId, error) => ({
  type: FETCH_FORM_FIELDS_ERROR,
  payload: { formId, error }
});

export const clearFormFields = () => ({
  type: CLEAR_FORM_FIELDS
});

// Async Actions
export const getFormFields = (formId, isReportGenerator = false) => async (dispatch, getState, { apiForms }) => {
  const state = getState();
  let header = selectorLogin.getHeaderConfig(state);
  header = { ...header, formOrigin: formOrigin['FORM_PRONTUARIO'] };

  try {
    dispatch(fetchFormFieldsRequest(formId));

    const response = await apiForms.form.getFormModelVersionLastVersion({
      header,
      formModelId: formId
    });

    // Extrair os campos do formulário
    const formData = response.data;
    const fields = [];
    
    // Processar as seções e campos do formulário
    if (formData.sections) {
      formData.sections.forEach(section => {
        if (section.modules) {
          section.modules.forEach(module => {
            if (module.fields) {
              module.fields.forEach(field => {
                fields.push({
                  ...field,
                  sectionName: section.name,
                  sectionId: section.id,
                  moduleId: module.id
                });
              });
            }
          });
        }
      });
    }

    const fieldsDashboardEvolution = fields.filter(field => {
      return isReportGenerator ? isFieldDataTypeReportGenerator(field.dataType) : isFieldDataTypeDashboardEvolution(field.dataType);
    });

    dispatch(fetchFormFieldsSuccess(formId, fieldsDashboardEvolution));
    
    return fields;
  } catch (error) {
    const { msg } = error;
    const customMsg = !!msg;

    util.managerExceptionURIMessage({ error, customMsg });
    dispatch(fetchFormFieldsError(formId, error));

    if (error && error.status === 401) {
      dispatch(actionConfig.routeRedirect('/'));
    }
    
    throw error;
  }
}; 